import CityPagePersianas from "../components/CityPagePersianas";

export default function PersianasMalaga() {
  return (
    <CityPagePersianas
      name="Málaga"
      slug="malaga"
      cp="29001-29018"
      poblacion={597173}
      zonaGeo="Capital de la Costa del Sol"
      lat={36.7213}
      lng={-4.4214}
      zonas={[
        "Centro Histórico",
        "Carretera de Cádiz",
        "El Palo",
        "Pedregalejo",
        "Teatinos",
        "Ciudad Jardín",
        "Huelin",
        "La Luz",
        "Trinidad",
        "Cruz de Humilladero",
      ]}
      landmarks={[
        "Catedral",
        "Alcazaba",
        "Calle Larios",
        "Muelle Uno",
        "Castillo de Gibralfaro",
        "Mercado Atarazanas",
      ]}
      municipiosLimitrofes={[
        "Torremolinos",
        "Cártama",
        "Alhaurín de la Torre",
        "Almogía",
        "Rincón de la Victoria",
      ]}
      festivalLocal="Feria de Málaga, segunda semana de agosto"
      contextoTipologico="Mix casco antiguo con tuberías antiguas, modernos áticos en Carretera de Cádiz, salitre marítimo intenso en barrios costeros, urbanizaciones de Teatinos en expansión."
      isCoreZone={true}
    />
  );
}